// Mobile Header Component
import Icon from '../common/Icon';
import './MobileHeader.css';

export default function MobileHeader({ title, onMenuClick, onBack, showBack, currentView, setCurrentView }) {
    const handleSettingsClick = () => {
        setCurrentView?.('settings');
    };

    const handleAccountClick = () => {
        setCurrentView?.('account');
    };

    return (
        <header className="mobile-header">
            {showBack ? (
                <button className="header-btn" onClick={onBack} title="Back">
                    <Icon name="ArrowLeft" />
                </button>
            ) : (
                <button className="header-btn" onClick={onMenuClick} title="Menu">
                    <Icon name="Menu" />
                </button>
            )}

            <h1 className="header-title">{title}</h1>

            <div className="header-actions">
                <button
                    className={`header-icon-btn ${currentView === 'settings' ? 'active' : ''}`}
                    onClick={handleSettingsClick}
                    title="Settings"
                >
                    <Icon name="Settings" />
                </button>
                <button
                    className={`header-icon-btn ${currentView === 'account' ? 'active' : ''}`}
                    onClick={handleAccountClick}
                    title="Account"
                >
                    <Icon name="User" />
                </button>
            </div>
        </header>
    );
}
